import { createFileRoute } from '@tanstack/react-router'
import { useHead } from '@unhead/react'
import { OneTimeCodeGeneration } from '@/features/auth/oneTimeCode/ui/OneTimeCodeGeneration'
import { validateTargetSearch } from '@/shared/config/searchParams'

export const Route = createFileRoute('/_signin/login')({
  validateSearch: validateTargetSearch,
  component: LoginComponent,
})

function LoginComponent() {
  useHead({
    title: 'Hello Screens - One Time Code',
    meta: [
      { name: 'description', content: 'One Time Code with Hello Screens' },
    ],
  })

  return (
    <OneTimeCodeGeneration />
  )
}
